const Snackbar = (id, time) => {
	var snackBar = document.getElementById(id);
	snackBar.className += " show";
	setTimeout(function(){ snackBar.className = snackBar.className.replace("show", ""); }, time);
}

export default Snackbar;